import { Table } from '@mantine/core'
import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { roundToDecimalPlaces } from '@semios/app-platform-common'
import { translate } from 'i18n/i18n'
import { removeCmOrInFromSoilProbeDepths } from 'utils/removeCmOrInFromSoilProbeDepths'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const OverridesTable = ({
  overrides,
  soilProbeDepthsAvailable,
}: {
  overrides?: routes.SoilCalibrationSettingsGet.Response['overrides']
  soilProbeDepthsAvailable: string[]
}) => {
  return (
    <div css={{ marginTop: 20 }}>
      <div
        css={{
          fontSize: 16,
          fontWeight: 'bold',
          marginBottom: 10,
          textAlign: 'center',
          textDecoration: 'underline',
        }}
      >
        {translate.phrases.banyanApp('FC/PWP overrides for each sensor of this station')}
      </div>
      <Table>
        <thead>
          <tr>
            <th>{translate.phrases.banyanApp('Depth')}</th>
            <th>{translate.phrases.banyanApp('Field Capacity (FC)')}</th>
            <th>{translate.phrases.banyanApp('Permanent Wilting Point (PWP)')}</th>
          </tr>
        </thead>
        <tbody>
          {soilProbeDepthsAvailable.map((depth) => {
            const depthInCm = removeCmOrInFromSoilProbeDepths(depth)
            const override = overrides?.[depthInCm.toString()]
            const depthLabel = unitConverter.soilDepth(depthInCm).valueWithSuffix()
            const fcValue = roundToDecimalPlaces(Number(override?.fieldCapacity), 4) ?? ''
            const pwpValue = roundToDecimalPlaces(Number(override?.permanentWiltingPoint), 4) ?? ''

            return (
              <tr key={depth}>
                <td>{depthLabel}</td>
                <td>{fcValue}</td>
                <td>{pwpValue}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}
